module.exports = __webpack_public_path__ + "static/mills-publishing-70a60fa169c05d4370748616958a63fd.jpg";